import React, { useEffect, useState } from 'react';
import AppointmentForm from '../../components/AppointmentForm';
import HomeBanner from '../../components/HomeBanner';
import ClientReview from '../../components/ClientReview';
import Certification from '../../components/Certification';
import PersonalizedSection from '../../components/PersonalizedSection';
import PersonalizedCarausel from '../../components/PersonalizedCarausel';
import PersonalizedNutrition from '../../components/PersonalizedNutrition';
import Explore from '../../components/Explore';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";
import HomePopupForm from '../../components/HomePopupForm';

const Home = ({ appointmentRef }) => {

  const [seoData, setSeoData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [hasPopupBeenShown, setHasPopupBeenShown] = useState(() => {
    return localStorage.getItem('popupShown') === 'true';
  })
  useEffect(() => {
    if (!hasPopupBeenShown) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('popupShown', 'true');
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, [hasPopupBeenShown]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("home");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <>
      <Helmet>
        {/* ================= PRIMARY META ================= */}
        <title>
          {seoData.metaTitle || "Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || ""}
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/"}
        />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || ""} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}
        <meta property="og:site_name" content="Nutrillion" />

        {/* ================= TWITTER CARD ================= */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || ""} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

        {/* ================= SCHEMA MARKUP (SEO API se) ================= */}
        {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>

      <HomePopupForm isOpen={showPopup} onClose={handleClosePopup} />

      <HomeBanner />
      <PersonalizedSection />
      <PersonalizedCarausel />
      <PersonalizedNutrition />
      <Explore />
      <Certification />
      <ClientReview />
      <div ref={appointmentRef}>
        <AppointmentForm />
      </div>
    </>
  );
};

export default Home;